import { CobranzasAxios, COMPANY, USER } from './config'

export const postWorks = async (data) => {
  const res = await CobranzasAxios.post(`/work/${COMPANY}`, data)
  return res.data
}

export const importWorks = async (data) => {
  const res = await CobranzasAxios.post(`/work/import/${COMPANY}`, data)
  return res.data
}

export const getWorks = async () => {
  const res = await CobranzasAxios.get(`/work/${COMPANY}`)
  return res.data
}

export const getFreeWorks = async () => {
  const res = await CobranzasAxios.get(`/work/tecnico/free/${COMPANY}`)
  return res.data
}

export const getWorksByUser = async (userId) => {
  const res = await CobranzasAxios.get(`/work/tecnico/${userId}/${COMPANY}`)
  return res.data
}

export const getAllWorks = async () => {
  const res = await CobranzasAxios.get(`/work/all/${COMPANY}`)
  return res.data
}

export const getWorksFiltered = async (data) => {
  const res = await CobranzasAxios.post(`/work/range-status/${COMPANY}`, data)
  return res.data
}

export const getWorksByDay = async (date) => {
  const res = await CobranzasAxios.get(`/work/${COMPANY}/${date}`)
  return res.data
}

export const putWorks = async (data, id) => {
  const res = await CobranzasAxios.put(`/work/${id}`, data)
  return res.data
}

export const addProductsToWork = async (data, workId) => {
  const res = await CobranzasAxios.put(`/work/add-products/${workId}`, data)
  return res.data
}

export const completeWork = async (workId, data = {}) => {
  const res = await CobranzasAxios.put(`/work/complete/${workId}`, data)
  return res.data
}

export const acceptWork = async (workId) => {
  const res = await CobranzasAxios.put(`/work/accept/${workId}/${USER}`, {})
  return res.data
}

export const deleteWork = async (workId, data) => {
  const res = await CobranzasAxios.put(`/work/delete/${workId}`, data)
  return res.data
}
